export const CoachmarkTour = {
  NewFieldInsightsDmb: 'web-field-selection-web.new-field-insights-dmb',
};

export const NEW_FIELD_INSIGHTS_TOUR_CONTINUE_IN_DMB_SESSION_KEY =
  'fieldSelectionWeb.continueNewFieldInsightsTourInDmb';
